import { post } from "../base";
import { get } from "../base";

//获取课程订单列表
export async function courseOrderList(params) {
    let respObj = await get("/organization/order/courselist",params);
    return respObj;
}
//获取发票信息 
export async function invoice(params) {
    let respObj = await get("/organization/order/invoice",params);
    return respObj;
}
//获取用户是否完善发票信息 
export async function getUserInvoiceInfo() {
    let respObj = await get("/api/course/invoice");
    return respObj;
}
//线下付款
export async function offlinePayment(params) {
    let respObj = await post("/organization/order/confirm-offline-pay",params);
    return respObj;
}
//获取签到管理列表
export async function courseSignManagerList(params) {
    let respObj = await get("/organization/siginin/schedules/" + params);
    return respObj;
}
//签到管理确认
export async function courseSignManagerConfirm(params) {
    let respObj = await post("/organization/siginin/add",params);
    return respObj;
}
//签到管理提交审核
export async function courseSignManagerSubmit(params) {
    let respObj = await post("/organization/siginin/addaudit",params);
    return respObj;
}
//删除签到管理图片
export function deleteSignImage(id){  
    return get('/organization/siginin/dels/' + id)
}